import React from 'react';
import CreatorPage from '../../features/apps/components/CreatorPage';

/** Creator page when from landing (unauthenticated). Clicks go to /store/:id. */
const StoreCreatorPageRoute = () => {
  return <CreatorPage fromLanding={true} />;
};

export default StoreCreatorPageRoute;
